const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  908: {
    path: "/stockManage",
    name: "stockManage",
    meta: {
      title: "库存管理",
      authId: "908",
      parentId: "1",
      cache: false
    }
  },
  90801: {
    path: "/warehousingList",
    name: "warehousingList",
    meta: {
      title: "入库管理",
      authId: "90801",
      parentId: "908",
      cache: false
    },
    auth: [
      {
        authId: "9080101",
        parentId: "90801",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      }
    ],
    component: _import("stockManage/warehousing/warehousingList")
  },
  90802: {
    path: "/stockList",
    name: "stockList",
    meta: {
      title: "库存管理",
      authId: "90802",
      parentId: "908",
      cache: false
    },
    auth: [
      {
        authId: "9080204",
        parentId: "90802",
        label: "库存对账单",
        category: "Button",
        type: "primary",
        handle: "handleStatementOfAccount"
      },
      {
        authId: "9080201",
        parentId: "90802",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9080203",
        parentId: "90802",
        label: "库存明细",
        handle: "handleDetail"
      },
      {
        authId: "9080202",
        parentId: "90802",
        label: "统计",
        handle: "look"
      }
    ],
    component: _import("stockManage/stock/stockList")
  },
  90803: {
    path: "/outboundList",
    name: "outboundList",
    meta: {
      title: "出库管理",
      authId: "90803",
      parentId: "908",
      cache: false
    },
    auth: [
      {
        authId: "9080301",
        parentId: "90803",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      }
    ],
    component: _import("stockManage/outbound/outboundList")
  },
  90804: {
    path: "/inventoryList",
    name: "inventoryList",
    meta: {
      title: "盘点管理",
      authId: "90804",
      parentId: "908",
      cache: false
    },
    auth: [
      {
        authId: "9080401",
        parentId: "90804",
        label: "创建盘点",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "gotoAdd",
        addRoutePath: [
          {
            authId: "9080404",
            name: "创建盘点",
            parentId: "90804"
          }
        ]
      },
      {
        authId: "9080402",
        parentId: "90804",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9080403",
        parentId: "90804",
        label: "查看",
        handle: "look"
      }
    ],
    component: _import("stockManage/inventory/inventoryList")
  },
  9080404: {
    path: "/addInventory",
    name: "addInventory",
    meta: {
      title: "创建盘点",
      authId: "9080404",
      parentId: "90804",
      cache: false,
      sideHidden: false,
      activePath: "/inventoryList"
    },
    component: _import("stockManage/inventory/addInventory")
  },
  90805: {
    path: "/allocationList",
    name: "allocationList",
    meta: {
      title: "调拨管理",
      authId: "90805",
      parentId: "908",
      cache: false
    },
    auth: [
      {
        authId: "9080501",
        parentId: "90805",
        label: "创建调拨",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "gotoAdd",
        addRoutePath: [
          {
            authId: "9080504",
            name: "创建调拨",
            parentId: "90805"
          }
        ]
      },
      {
        authId: "9080502",
        parentId: "90805",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      {
        authId: "9080503",
        parentId: "90805",
        label: "查看",
        handle: "look"
      }
    ],
    component: _import("stockManage/allocation/allocationList")
  },
  9080504: {
    path: "/addAllocation",
    name: "addAllocation",
    meta: {
      title: "创建调拨",
      authId: "9080504",
      parentId: "90805",
      cache: false,
      sideHidden: false,
      activePath: "/allocationList"
    },
    component: _import("stockManage/allocation/addAllocation")
  },
  90806: {
    path: "/earlyWarningList",
    name: "earlyWarningList",
    meta: {
      title: "库存预警",
      authId: "90806",
      parentId: "908",
      cache: false
    },
    auth: [
      {
        authId: "9080601",
        parentId: "90806",
        label: "去补货",
        category: "Button",
        type: "primary",
        handle: "gotoReplenishment"
      },
      {
        authId: "9080602",
        parentId: "90806",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      }
    ],
    component: _import("stockManage/earlyWarning/earlyWarningList")
  },
  90807: {
    path: "/benefitCardManage",
    name: "benefitCardManage",
    meta: {
      title: "权益卡管理",
      authId: "90807",
      parentId: "908",
      cache: false
    },
    auth: [
      {
        authId: "9080701",
        parentId: "90807",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      }
    ],
    component: _import("stockManage/BenefitCardManage/index")
  }
}
